<template>
  <div :class="success ?  'TalkToAgent' : 'TalkToAgent__error' ">
    <div class="TalkToAgent__header">
      <span>Response from Agent</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="TalkToAgent__body">
        <div style="margin-bottom: 10px">
          <span style="white-space: pre-wrap">{{ outputObject.result }}</span>
        </div>
        <div class="TalkToAgent__message_chain" v-if="outputObject.messages_chain.length > 2">
          <h4>Message Chain <v-btn icon @click="extendMessages = !extendMessages"><v-icon> {{ extendMessages ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn></h4>
          <div v-if="extendMessages"
               style="
                  border-top: #00a1fb 1px solid;
                  padding-top: 10px;
                  overflow-y: auto;
                  height: 200px;
               "
          >
            <div v-for="(message, index) in outputObject.messages_chain" :key="index" class="TalkToAgent__message">

              <p style="font-weight: bold" class="TalkToAgent__user">{{ message.role === 'assistant' ? 'Agent' : 'User' }}: </p>

              <div v-for="(content, index) in message.content" :key="index+'_content'" class="TalkToAgent__message_content">

                <div v-if="content.type !== 'tool_use' && content.type !== 'tool_result'">
                  <span style="white-space: pre-wrap">{{ content.text || content.thinking }}</span>
                </div>

                <div v-if="content.type === 'tool_use'">
                  <p>Execute Action: {{ content.name }}</p>
                  <json-viewer
                      :expand-depth=0
                      :value="typeof content.input !== 'string' ? content.input : JSON.parse(content.input)"
                      style="white-space: pre-line; border-radius: 15px; width: 100%"
                  ></json-viewer>
                </div>

                <div v-if="content.type === 'tool_result'">
                  <p>Action Result: </p>
                  <json-viewer
                      :expand-depth=0
                      :value="typeof content.content !== 'string' ? content.content : JSON.parse(content.content)"
                      style="white-space: pre-line; border-radius: 15px; width: 100%"
                  ></json-viewer>
                </div>

              </div>
            </div>
            <div class="TalkToAgent__message">
              <p style="font-weight: bold" class="TalkToAgent__user">{{ 'Agent' }}</p>
              <div class="TalkToAgent__message_content">
                {{ outputObject.result }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="TalkToAgent__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !success">
      <div class="DefaultAction__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'talk-to-agent-action-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
      extendMessages: false,
    };
  },
  computed: {
    outputObject() {
      if(!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import './index';
</style>
